module.exports = __webpack_public_path__ + "img/firmenlogo.44ff65d4.png";